import React from "react";

type Props = {
  variant?: "Enrich";
  testId?: string;
  caption?: string;
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
};

export const PromptSliderField: React.FC<Props> = ({
  variant,
  testId,
  caption,
  label,
  min,
  max,
  step,
  value,
  setValue,
}) => {
  const Wrapper = variant === "Enrich" ? "div" : "form";

  return (
    <Wrapper className="txu-form-field">
      <label
        data-balloon={caption}
        data-balloon-pos="up-left"
        data-balloon-length="xlarge"
        className={`${variant == "Enrich" && "tw-text-sm tw-text-gray-700"}`}
      >
        {label}
      </label>
      <div
        className={`${
          variant == "Enrich" &&
          "tw-flex !tw-flex-row-reverse tw-justify-end tw-items-center"
        }`}
      >
        <p
          className={`${variant == "Enrich" && "tw-text-sm tw-text-gray-500"}`}
        >
          Value: {value || "OpenRouter default"}
        </p>
        <input
          className={`${variant != "Enrich" && "tw-w-full"}`}
          data-testid={testId}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => setValue(Number(e.target.value))}
        />
      </div>
    </Wrapper>
  );
};
